var cov_19iv1uevjt = function () {
  var path = "/Users/spana/SHEIN/shineout/src/hoc/config.tsx",
      hash = "95059c1f9c13615233ebfbaa7541330214f36500",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/hoc/config.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 21,
          column: 3
        }
      },
      "1": {
        start: {
          line: 9,
          column: 6
        },
        end: {
          line: 9,
          column: 18
        }
      },
      "2": {
        start: {
          line: 10,
          column: 6
        },
        end: {
          line: 10,
          column: 53
        }
      },
      "3": {
        start: {
          line: 11,
          column: 6
        },
        end: {
          line: 11,
          column: 45
        }
      },
      "4": {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 15,
          column: 47
        }
      },
      "5": {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 19,
          column: 36
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 16
          },
          end: {
            line: 4,
            column: 17
          }
        },
        loc: {
          start: {
            line: 5,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        },
        line: 5
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 8,
            column: 4
          },
          end: {
            line: 8,
            column: 5
          }
        },
        loc: {
          start: {
            line: 8,
            column: 26
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 8
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 14,
            column: 4
          },
          end: {
            line: 14,
            column: 5
          }
        },
        loc: {
          start: {
            line: 14,
            column: 27
          },
          end: {
            line: 16,
            column: 5
          }
        },
        line: 14
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 18,
            column: 5
          }
        },
        loc: {
          start: {
            line: 18,
            column: 13
          },
          end: {
            line: 20,
            column: 5
          }
        },
        line: 18
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/hoc/config.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { noti } from '../config';
export default (function (Com, name) {
  var _temp;

  cov_19iv1uevjt.f[0]++;
  cov_19iv1uevjt.s[0]++;
  return _temp =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(_temp, _React$Component);

    var _super = _createSuper2(_temp);

    function _temp(props) {
      var _this;

      _classCallCheck(this, _temp);

      cov_19iv1uevjt.f[1]++;
      cov_19iv1uevjt.s[1]++;
      _this = _super.call(this, props);
      _this.handleUpdate = void 0;
      cov_19iv1uevjt.s[2]++;
      _this.handleUpdate = _this.forceUpdate.bind(_assertThisInitialized(_this));
      cov_19iv1uevjt.s[3]++;
      noti.subscribe(name, _this.handleUpdate);
      return _this;
    }

    _createClass(_temp, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        cov_19iv1uevjt.f[2]++;
        cov_19iv1uevjt.s[4]++;
        noti.unsubscribe(name, this.handleUpdate);
      }
    }, {
      key: "render",
      value: function render() {
        cov_19iv1uevjt.f[3]++;
        cov_19iv1uevjt.s[5]++;
        return (
          /*#__PURE__*/
          React.createElement(Com, Object.assign({}, this.props, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 19,
              columnNumber: 14
            }
          }))
        );
      }
    }]);

    return _temp;
  }(React.Component), _temp;
});